import React from 'react';
const SHIFTS = [{
  before: 'Instead of checking Venmo...',
  after: 'you already know who owes you.'
}, {
  before: 'Instead of losing students...',
  after: 'you already have a follow-up system.'
}];
export function Reviews() {
  return <div className="px-5 pt-6" data-id="element-188" data-mp="2me1osypdiraz">
      <div className="mx-auto max-w-xl rounded-3xl border border-white/20 bg-[#101b2d]/95 p-5 text-center shadow-xl shadow-black/25" data-id="element-189" data-mp="2rbbf0gkl76zv">
        <p className="font-display text-2xl font-800 uppercase leading-[0.95] text-white" data-id="element-190" data-mp="2w9d53lgfk6ku">
          Imagine finishing your last lesson...
        </p>
        <p className="mt-2 text-sm font-600 text-white/70" data-id="element-191" data-mp="352gijtr2sjfh">
          instead of wondering
        </p>
        <p className="mt-1 font-display text-xl font-800 leading-tight text-[var(--pb-lime)]" data-id="element-192" data-mp="3a1t1w4iqn8db">
          “What am I teaching tomorrow?”
        </p>
        <p className="mt-3 text-sm font-700 text-white/95" data-id="element-193" data-mp="3f1xhlsbtnz2h">
          Everything is already planned.
        </p>

        <div className="my-4 h-px bg-white/15" data-id="element-194" data-mp="3jxcxepte451j" />

        <div className="space-y-2.5 text-sm leading-snug" data-id="element-195" data-mp="2rcxh77mqx3v5">
          {SHIFTS.map(shift => <p key={shift.before} data-id="element-196" data-mp="2mdb3yy6x3nmc">
              <span className="text-white/65" data-id="element-197" data-mp="2mc9gtvcmnao9">{shift.before}</span>{' '}
              <span className="font-700 text-white" data-id="element-198" data-mp="2hfj2bcgh0n4y">{shift.after}</span>
            </p>)}
        </div>

        <p className="mt-4 text-sm leading-snug text-white/75" data-id="element-199" data-mp="2de7ijnka2w4o">
          Instead of feeling like you’re constantly catching up...
        </p>
        <p className="mt-1 font-display text-xl font-800 uppercase leading-tight text-[var(--pb-lime)]" data-id="element-200" data-mp="3542alrziszx1">
          your coaching business finally runs like a business.
        </p>
      </div>
    </div>;
}